var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "travel-container" },
    [
      _c("header", { staticClass: "trv-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("h1", { staticClass: "trv-title" }, [_vm._v("行迹 · 旅途")]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "trv-sub" },
          [
            _vm._v("\n      循迹山海 · 拾景为记 —— jmdvirus\n      "),
            _c(
              "router-link",
              { staticClass: "trv-link", attrs: { to: "/travelmng" } },
              [_vm._v("旅途管理")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trv-filter" },
        [
          _c("el-input", {
            staticClass: "trv-search",
            attrs: {
              placeholder: "搜索标题 / 副标题 / 作者 / 内容",
              "prefix-icon": "el-icon-search",
              clearable: "",
            },
            on: { input: _vm.onSearch },
            model: {
              value: _vm.searchKeyword,
              callback: function ($$v) {
                _vm.searchKeyword = $$v
              },
              expression: "searchKeyword",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "trv-select",
              attrs: { placeholder: "按标题筛选", clearable: "" },
              on: { change: _vm.onCategoryChange },
              model: {
                value: _vm.selectedCategory,
                callback: function ($$v) {
                  _vm.selectedCategory = $$v
                },
                expression: "selectedCategory",
              },
            },
            [
              _c("el-option", { attrs: { label: "全部行程", value: "" } }),
              _vm._v(" "),
              _vm._l(_vm.categories, function (c) {
                return _c("el-option", {
                  key: c,
                  attrs: { label: c, value: c },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "trv-sort" },
            _vm._l(_vm.sortOptions, function (opt) {
              return _c(
                "button",
                {
                  key: opt.value,
                  class: { "is-active": _vm.sortOrder === opt.value },
                  on: {
                    click: function ($event) {
                      _vm.sortOrder = opt.value
                    },
                  },
                },
                [_vm._v(_vm._s(opt.label))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("span", { staticClass: "trv-stats" }, [
            _vm._v("共 " + _vm._s(_vm.total) + " 段旅程"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayItems.length
        ? _c(
            "div",
            { staticClass: "trv-body" },
            _vm._l(_vm.timelineGroups, function (group) {
              return _c(
                "section",
                { key: group.year, staticClass: "trv-year" },
                [
                  _c("div", { staticClass: "trv-year-head" }, [
                    _c("span", { staticClass: "trv-year-num" }, [
                      _vm._v(_vm._s(group.year)),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "trv-year-rule" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "trv-year-count" }, [
                      _vm._v(_vm._s(group.items.length) + " 段"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "trv-cards" },
                    _vm._l(group.items, function (item, idx) {
                      return _c(
                        "article",
                        {
                          key: item.title + "-" + item.createTime + "-" + idx,
                          staticClass: "trv-card",
                          style: {
                            animationDelay: Math.min(idx, 8) * 60 + "ms",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openDetail(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "trv-cover" }, [
                            _vm.coverOf(item)
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.mediaUrl(_vm.coverOf(item)),
                                    alt: "",
                                    loading: "lazy",
                                  },
                                })
                              : _c("div", { staticClass: "trv-cover-empty" }, [
                                  _c("span", [
                                    _vm._v(_vm._s((item.title || "旅")[0])),
                                  ]),
                                ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "trv-date" }, [
                              _vm._v(_vm._s(_vm.formatDay(item))),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "trv-cover-veil" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "trv-card-body" }, [
                            _c("h3", { staticClass: "trv-card-title" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                            _vm._v(" "),
                            item.subtitle
                              ? _c("p", { staticClass: "trv-card-sub" }, [
                                  _vm._v(_vm._s(item.subtitle)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", { staticClass: "trv-card-excerpt" }, [
                              _vm._v(_vm._s(_vm.excerpt(item.content, 68))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "trv-card-meta" }, [
                              _vm.trackCount(item)
                                ? _c("span", { staticClass: "trv-meta-item" }, [
                                    _c("i", {
                                      staticClass: "el-icon-map-location",
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.trackCount(item)) + " 点"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.imageCount(item)
                                ? _c("span", { staticClass: "trv-meta-item" }, [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.imageCount(item)) + " 张"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.videoCount(item)
                                ? _c("span", { staticClass: "trv-meta-item" }, [
                                    _c("i", {
                                      staticClass: "el-icon-video-camera",
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.videoCount(item)) + " 段"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(1, true),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          )
        : !_vm.isLoading
        ? _c("div", { staticClass: "trv-empty" }, [
            _c("span", { staticClass: "trv-empty-badge" }, [_vm._v("未至")]),
            _vm._v(" "),
            _c("p", [_vm._v("尚无此段旅程")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMore
        ? _c("div", { staticClass: "trv-more" }, [
            _c(
              "button",
              {
                staticClass: "trv-more-btn",
                class: { "is-loading": _vm.isLoading },
                on: { click: _vm.queryTravel },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.isLoading ? "正在溯源…" : "继续前行") +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "trv-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: _vm.dialogWidth,
            top: _vm.isMobile ? "4vh" : "15vh",
            center: "",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            opened: _vm.onDialogOpened,
            closed: _vm.onDialogClosed,
          },
        },
        [
          _vm.selectedItem
            ? _c("div", { staticClass: "trv-dialog-content" }, [
                _c(
                  "button",
                  {
                    staticClass: "trv-dialog-close",
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = false
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-close" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "trv-dialog-head" }, [
                  _c("h3", { staticClass: "trv-dialog-title" }, [
                    _vm._v(_vm._s(_vm.selectedItem.title)),
                  ]),
                  _vm._v(" "),
                  _vm.selectedItem.subtitle
                    ? _c("p", { staticClass: "trv-dialog-sub" }, [
                        _vm._v(_vm._s(_vm.selectedItem.subtitle)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "trv-dialog-meta" }, [
                    _vm.selectedItem.author
                      ? _c("span", [_vm._v(_vm._s(_vm.selectedItem.author))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.selectedItem.createtime))]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "trv-block",
                    class: { "is-fullscreen": _vm.mapFullscreen },
                  },
                  [
                    _c("div", { staticClass: "trv-block-head" }, [
                      _c("span", { staticClass: "trv-block-label" }, [
                        _vm._v("足迹 · 轨迹"),
                      ]),
                      _vm._v(" "),
                      _vm.trackPointCount && !_vm.mapError
                        ? _c("div", { staticClass: "trv-map-tools" }, [
                            _c("span", { staticClass: "trv-tool-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "trv-tool-btn",
                                  class: {
                                    "is-active": _vm.mapLayer === "normal",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setMapLayer("normal")
                                    },
                                  },
                                },
                                [_vm._v("标准")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "trv-tool-btn",
                                  class: {
                                    "is-active": _vm.mapLayer === "satellite",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setMapLayer("satellite")
                                    },
                                  },
                                },
                                [_vm._v("卫星")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "trv-tool-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "trv-tool-btn",
                                  class: {
                                    "is-active":
                                      !_vm.elevationColor || !_vm.hasElevation,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setElevationColor(false)
                                    },
                                  },
                                },
                                [_vm._v("单色")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "trv-tool-btn",
                                  class: {
                                    "is-active":
                                      _vm.elevationColor && _vm.hasElevation,
                                  },
                                  attrs: {
                                    disabled: !_vm.hasElevation,
                                    title: _vm.hasElevation
                                      ? ""
                                      : "该轨迹无海拔数据",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setElevationColor(true)
                                    },
                                  },
                                },
                                [_vm._v("海拔")]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.imageList.length
                              ? _c("span", { staticClass: "trv-tool-group" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "trv-tool-btn",
                                      class: { "is-active": _vm.showPhotos },
                                      attrs: {
                                        title: _vm.showPhotos
                                          ? "隐藏地图上的照片，只看轨迹"
                                          : "在地图上显示照片",
                                      },
                                      on: { click: _vm.togglePhotos },
                                    },
                                    [_vm._v("显示图片")]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "trv-tool-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "trv-tool-btn",
                                  class: { "is-active": _vm.mapFullscreen },
                                  on: { click: _vm.toggleMapFullscreen },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.mapFullscreen ? "退出全屏" : "全屏"
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "trv-map-wrap" }, [
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.trackPointCount && !_vm.mapError,
                            expression: "trackPointCount && !mapError",
                          },
                        ],
                        ref: "travelMap",
                        staticClass: "trv-map",
                      }),
                      _vm._v(" "),
                      _vm.mapError
                        ? _c("div", { staticClass: "trv-map-tip" }, [
                            _vm._v(_vm._s(_vm.mapError)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.elevationColor && _vm.hasElevation
                        ? _c("div", { staticClass: "trv-elev-legend" }, [
                            _c("span", { staticClass: "trv-elev-end" }, [
                              _vm._v(
                                _vm._s(Math.round(_vm.elevRange.min)) + "m"
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "trv-elev-bar" },
                              _vm._l(_vm.elevationPalette, function (c, i) {
                                return _c("i", {
                                  key: "el" + i,
                                  style: { background: c },
                                })
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "trv-elev-end" }, [
                              _vm._v(
                                _vm._s(Math.round(_vm.elevRange.max)) + "m"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeCluster && _vm.stripPos
                        ? _c(
                            "div",
                            {
                              staticClass: "trv-strip",
                              class: {
                                "is-left": _vm.stripPos.side === "left",
                              },
                              style: {
                                left: _vm.stripPos.x + "px",
                                top: _vm.stripPos.y + "px",
                              },
                            },
                            [
                              _c("div", { staticClass: "trv-strip-head" }, [
                                _c("span", { staticClass: "trv-strip-time" }, [
                                  _vm._v(_vm._s(_vm.activeCluster.label)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "trv-strip-count" }, [
                                  _vm._v(
                                    _vm._s(_vm.activeCluster.photos.length) +
                                      " 张"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "trv-strip-close",
                                    on: { click: _vm.closeCluster },
                                  },
                                  [_c("i", { staticClass: "el-icon-close" })]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "trv-strip-body" },
                                _vm._l(
                                  _vm.activeCluster.photos,
                                  function (img, i) {
                                    return _c(
                                      "figure",
                                      {
                                        key: "sb" + i,
                                        staticClass: "trv-strip-figure",
                                      },
                                      [
                                        _c(
                                          "el-image",
                                          {
                                            staticClass: "trv-thumb",
                                            attrs: {
                                              src: _vm.mediaUrl(
                                                img.thumbUrl || img.url
                                              ),
                                              fit: "cover",
                                              lazy: "",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.openViewer(
                                                  _vm.activeCluster.photos,
                                                  i
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "trv-thumb-error",
                                                attrs: { slot: "error" },
                                                slot: "error",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-picture-outline",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        img.desc
                                          ? _c(
                                              "figcaption",
                                              { staticClass: "trv-strip-cap" },
                                              [_vm._v(_vm._s(img.desc))]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.showPhotos &&
                _vm.imageList.length &&
                (!_vm.photoLayout.hasTrackTime ||
                  _vm.photoLayout.unmatched.length)
                  ? _c(
                      "div",
                      { staticClass: "trv-block" },
                      [
                        _vm.photoLayout.hasTrackTime
                          ? [
                              _vm.photoLayout.unmatched.length
                                ? _c("div", { staticClass: "trv-unmatched" }, [
                                    _c(
                                      "p",
                                      { staticClass: "trv-unmatched-title" },
                                      [
                                        _vm._v(
                                          "未与轨迹对应的照片（" +
                                            _vm._s(
                                              _vm.photoLayout.unmatched.length
                                            ) +
                                            " 张）"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "trv-grid" },
                                      _vm._l(
                                        _vm.photoLayout.unmatched,
                                        function (img, i) {
                                          return _c(
                                            "figure",
                                            {
                                              key: "un" + i,
                                              staticClass: "trv-figure",
                                            },
                                            [
                                              _c(
                                                "el-image",
                                                {
                                                  staticClass: "trv-cell",
                                                  attrs: {
                                                    src: _vm.mediaUrl(
                                                      img.thumbUrl || img.url
                                                    ),
                                                    fit: "cover",
                                                    lazy: "",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.openViewer(
                                                        _vm.photoLayout
                                                          .unmatched,
                                                        i
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "trv-thumb-error",
                                                      attrs: { slot: "error" },
                                                      slot: "error",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-picture-outline",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              img.desc
                                                ? _c(
                                                    "figcaption",
                                                    {
                                                      staticClass:
                                                        "trv-cell-cap",
                                                    },
                                                    [_vm._v(_vm._s(img.desc))]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          : _c(
                              "div",
                              { staticClass: "trv-grid" },
                              _vm._l(_vm.imageList, function (img, i) {
                                return _c(
                                  "figure",
                                  { key: "img" + i, staticClass: "trv-figure" },
                                  [
                                    _c(
                                      "el-image",
                                      {
                                        staticClass: "trv-cell",
                                        attrs: {
                                          src: _vm.mediaUrl(
                                            img.thumbUrl || img.url
                                          ),
                                          fit: "cover",
                                          lazy: "",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.openViewer(
                                              _vm.imageList,
                                              i
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "trv-thumb-error",
                                            attrs: { slot: "error" },
                                            slot: "error",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-picture-outline",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    img.desc
                                      ? _c(
                                          "figcaption",
                                          { staticClass: "trv-cell-cap" },
                                          [_vm._v(_vm._s(img.desc))]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.videoList.length
                  ? _c("div", { staticClass: "trv-block" }, [
                      _c("div", { staticClass: "trv-block-head" }, [
                        _c("span", { staticClass: "trv-block-label" }, [
                          _vm._v("影像 · 视频"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "trv-block-meta" }, [
                          _vm._v(_vm._s(_vm.videoList.length) + " 段"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "trv-video-grid" },
                        _vm._l(_vm.videoList, function (v, i) {
                          return _c(
                            "div",
                            { key: "vid" + i, staticClass: "trv-video-cell" },
                            [
                              _c("video", {
                                attrs: {
                                  src: _vm.mediaUrl(v.url),
                                  controls: "",
                                  preload: "metadata",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "trv-video-name" }, [
                                _vm._v(_vm._s(v.name || "视频" + (i + 1))),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.formatContent(_vm.selectedItem.content).length
                  ? _c("div", { staticClass: "trv-block" }, [
                      _c("div", { staticClass: "trv-block-head" }, [
                        _c("span", { staticClass: "trv-block-label" }, [
                          _vm._v("行记 · 见闻"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "trv-note" },
                        _vm._l(
                          _vm.formatContent(_vm.selectedItem.content),
                          function (line, idx) {
                            return _c(
                              "p",
                              { key: idx, staticClass: "trv-note-line" },
                              [_vm._v(_vm._s(line))]
                            )
                          }
                        ),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "trv-dialog-foot" }, [
                  _vm._v("收录于 " + _vm._s(_vm.selectedItem.createtime)),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.viewerVisible
        ? _c(
            "div",
            { staticClass: "trv-viewer", on: { click: _vm.closeViewer } },
            [
              _c("div", {
                key: "bg" + _vm.viewerIndex,
                staticClass: "trv-viewer-bg",
                style: _vm.viewerBackdropStyle,
              }),
              _vm._v(" "),
              _c("div", { staticClass: "trv-viewer-scrim" }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "trv-viewer-close",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.closeViewer.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-close" })]
              ),
              _vm._v(" "),
              _vm.viewerList.length > 1
                ? _c(
                    "span",
                    {
                      staticClass: "trv-viewer-count",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.viewerIndex + 1) +
                          " / " +
                          _vm._s(_vm.viewerList.length)
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewerList.length > 1
                ? _c(
                    "button",
                    {
                      staticClass: "trv-viewer-nav is-prev",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.viewerPrev.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-arrow-left" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewerList.length > 1
                ? _c(
                    "button",
                    {
                      staticClass: "trv-viewer-nav is-next",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.viewerNext.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-arrow-right" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "trv-viewer-stage" }, [
                _c("img", {
                  staticClass: "trv-viewer-img",
                  attrs: {
                    src: _vm.viewerCurrent.url,
                    alt: _vm.viewerCurrent.desc,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onViewerImgClick.apply(null, arguments)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _vm.viewerCurrent.desc
                ? _c(
                    "p",
                    {
                      staticClass: "trv-viewer-cap",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.viewerCurrent.desc))]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "trv-route", attrs: { "aria-hidden": "true" } },
      [
        _c("span", { staticClass: "trv-dot" }),
        _c("i"),
        _c("span", { staticClass: "trv-plane" }, [_vm._v("✈")]),
        _c("i"),
        _c("span", { staticClass: "trv-dot" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "trv-open" }, [
      _vm._v("展开行程"),
      _c("i", { staticClass: "el-icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }